import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export const updateOnlyDifferencePreference = async (value: boolean = false) => {
  const url = occUrl("/preferences/product-comparison");

  const response = await occFetch(url, {
    method: "PATCH",
    cache: "no-cache",
    headers: {
      "content-type": "application/json",
    },
    body: JSON.stringify({ showOnlyDifference: value }),
  });

  if (!response.ok) {
    throw new Error(`Failed to update showOnlyDifference: ${response.status}`);
  }
};
